<template>
  <div class="home-page-banner-container">
    <img src="@/assets/images/home-bg.png" alt="" />
    <div class="banner-title-container">
      <div class="main-title wow fadeInLeft" data-wow-duration="0.6s">
        <img src="@/assets/images/banner-title.png" alt="" />
      </div>
      <div
        class="sub-title wow fadeInLeft"
        data-wow-delay="0.1s"
        data-wow-duration="0.6s"
      >
        <img src="@/assets/images/banner-sub-title.png" alt="" />
      </div>
      <div
        class="consult-btn wave wow fadeInLeft"
        data-wow-delay="0.2s"
        data-wow-duration="0.6s"
        @click="openContactCard"
      >
        <span>咨询了解服务</span>
      </div>
    </div>
    <div class="product-center-count-cards-container">
      <div
        class="product-center-count-cards wow fadeInUp"
        data-wow-duration="0.6s"
      >
        <div class="product-center-count-card">
          <div class="count-card-left">
            <div class="card-count">
              <span>2.3</span>
              <span class="unit">万+</span>
            </div>
            <div class="card-label">
              <span>服务客户</span>
            </div>
          </div>
          <div class="count-card-right">
            <img src="@/assets/images/icon-customer.png" alt="" />
          </div>
        </div>
        <div class="product-center-count-card">
          <div class="count-card-left">
            <div class="card-count">
              <span>100</span>
              <span class="unit">+</span>
            </div>
            <div class="card-label">
              <span>支持业务场景</span>
            </div>
          </div>
          <div class="count-card-right">
            <img src="@/assets/images/icon-bag.png" alt="" />
          </div>
        </div>
        <div class="product-center-count-card">
          <div class="count-card-left">
            <div class="card-count">
              <span>10</span>
              <span class="unit">+</span>
            </div>
            <div class="card-label">
              <span>医院覆盖</span>
            </div>
          </div>
          <div class="count-card-right">
            <img src="@/assets/images/icon-hospital.png" alt="" />
          </div>
        </div>
        <div class="product-center-count-card">
          <div class="count-card-left">
            <div class="card-count">
              <span>12.6</span>
              <span class="unit">万+</span>
            </div>
            <div class="card-label">
              <span>医疗档案</span>
            </div>
          </div>
          <div class="count-card-right">
            <img src="@/assets/images/icon-document.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <contact-card ref="contactCard"></contact-card>
  </div>
</template>

<script>
import contactCard from "@/view/components/contactCardDialog";
export default {
  components: {
    contactCard,
  },
  data() {
    return {};
  },
  methods: {
    openContactCard() {
      this.$refs.contactCard.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.home-page-banner-container {
  position: relative;
  padding-top: 70px;
  width: 100%;
  min-height: 500px;
  background: #0043DA;
  img {
    width: 100%;
  }
  .banner-title-container {
    position: absolute;
    top: 30%;
    left: 10%;
    height: 30%;
    .main-title {
      img {
        width: 50%;
      }
    }
    .sub-title {
      margin-top: 4%;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #ffffff;
      img {
        width: 30%;
      }
    }
    .consult-btn {
      margin-top: 4%;
      width: 136px;
      height: 40px;
      border: 1px solid #ffffff;
      border-radius: 20px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      @include btn;
    }
  }
  .product-center-count-cards-container {
    width: 100%;
    height: 150px;
    position: absolute;
    bottom: -100px;
    // top: -5%;
    z-index: 9;
    @include flexCenter;
    .product-center-count-cards {
      width: 75%;
      max-width: 1100px;
      height: 150px;
      background: #ffffff;
      border: 1px solid #e9eef5;
      border-radius: 2px;
      display: flex;
    }
    .product-center-count-card {
      width: 25%;
      height: 100%;
      padding: 20px;
      &:not(:last-child) {
        border-right: 1px solid #e9eef5;
      }
      @include flexBetween;
      .count-card-left {
        .card-count {
          display: flex;
          font-family: PingFangSC-Medium;
          font-size: 40px;
          line-height: 40px;
          color: #222222;
          .unit {
            margin-left: 4px;
            font-size: 16px;
            line-height: 24px;
          }
        }
        .card-label {
          margin-top: 10px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #222222;
        }
      }
      .count-card-right {
        height: 100%;
        display: flex;
        align-items: flex-end;
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/banner.vue